import InfiniteProducts from '../assets/infinite_products.png'

const Home = ({ MarginTop }) => {

    return (
        <section id="home" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                <div className="title-section">
                    <h1 className="head-title">Welcome to <span>BWE Financial</span> Services</h1>
                    <span className="title-under-line"></span>
                </div>
                <p>BWE is a revolutionary FinTech Platform, forged through the collaboration of visionaries determined to address the pressing issues faced by both borrowers and lenders.
                    Transform your lending operations with a <b className='bold_text'>loan origination system</b> built for speed and flexibility.</p>
                <p>Our platform combines an intuitive, lightning-fast interface with <b className='bold_text'>infinitely configurable products</b>, empowering your team to adapt to any lending scenario without compromise. </p>
                <div style={{ width: '100%', height: 'auto', marginBottom: '20px' }}>
                    <img src={InfiniteProducts} alt='Infinite Products' />
                </div>
                <p>Whether you're originating personal loans, home loans, commercial loans, or consumer credit, experience the difference when powerful technology meets exceptional design; so you can focus on what matters most: closing more loans and delighting your customers.</p>
                <p>From initial customer record intake through underwriting, approval, and final loan disbursement, manage your entire lending lifecycle in one seamless workflow. Design workflows that match how your team actually works, not the other way around.</p>
            </div>
        </section>
    );
};

export default Home;